import React from 'react';

import styles from './ThingsToKnow.module.css';

type ThingsToKnowProp = {
  text1?: string;
  text2?: string;
  html?: string | null;
};
const ThingsToKnow = ({
  text1 = '',
  text2 = '',
  html = ''
}: ThingsToKnowProp) => {
  return (
    <div className={styles.thingsToKnowWarp}>
      {(() => {
        if (html) {
          return (
            <span
              className={`${styles.thingsToKnowText} thingstoKnow`}
              dangerouslySetInnerHTML={{ __html: html }}
            ></span>
          );
        } else {
          return (
            <>
              {text1 ? (
                <p
                  className={`${text2 ? 'appendBottom20' : ''} ${
                    styles.thingsToKnowText
                  }`}
                >
                  {text1}
                </p>
              ) : null}
              {text2 ? (
                <p className={styles.thingsToKnowText}>{text2}</p>
              ) : null}
            </>
          );
        }
      })()}
    </div>
  );
};

export default ThingsToKnow;
